import { Card, Col, Container, Row } from "react-bootstrap"
import { CheckCircle, FileText, Headset, Printer, ShieldCheck, Truck } from "react-bootstrap-icons";

export const Recursos = () => {
    const recursos = [
        {
            icon: <FileText size={40} className="text-primary" />,
            title: "Emissão de MDF-e",
            desc: "Emita manifestos eletrônicos de forma simples e rápida, com validação automática."
        },
        {
            icon: <Truck size={40} className="text-success" />,
            title: "Inclusão de Condutor",
            desc: "Adicione novos motoristas ao manifesto a qualquer momento, sem burocracia."
        },
        {
            icon: <CheckCircle size={40} className="text-warning" />,
            title: "Encerramento e Cancelamento",
            desc: "Finalize ou cancele seus manifestos de forma segura e validada pela SEFAZ."
        },
        {
            icon: <Printer size={40} className="text-secondary" />,
            title: "Impressão DAMDFE",
            desc: "Gere e imprima o Documento Auxiliar de Manifesto Eletrônico facilmente."
        },
        {
            icon: <ShieldCheck size={40} className="text-info" />,
            title: "Segurança de Dados",
            desc: "Seus dados e documentos protegidos com criptografia e backups automáticos."
        },
        {
            icon: <Headset size={40} className="text-danger" />,
            title: "Suporte Prioritário",
            desc: "Atendimento rápido e especializado para resolver suas dúvidas e problemas."
        }
    ];
    return (<>
        <section id="recursos" >
            <Container>
                <h1 className="text-center mb-4 fw-bold">Recursos do MDF-e</h1>
                <p className="text-center text-muted mb-5">
                    Tudo que você precisa para gerenciar seus manifestos em um único lugar, com praticidade e segurança.
                </p>

                <Row>
                    {recursos.map((item, index) => (
                        <Col md={4} sm={6} xs={12} className="mb-4" key={index}>
                            <Card className="h-100 shadow-sm border-0">
                                <Card.Body className="text-center">
                                    <div className="mb-3">{item.icon}</div>
                                    <p className="text-uppercase">{item.title}</p>
                                    <Card.Text className="text-muted">{item.desc}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    </>)
}